import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex justify-between card-header border-0" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "my-1" }
const _hoisted_7 = { class: "p-input-icon-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "card-toolbar" }
const _hoisted_10 = { "data-kt-customer-table-toolbar": "base" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = { class: "card-body pt-0" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "badge border-white text-green-800 bg-green-200 p-4"
}
const _hoisted_16 = {
  key: 1,
  class: "badge border-white text-red-800 bg-red-200 p-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)
const _hoisted_18 = ["href"]

import { ref, onMounted } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { useRoute } from "vue-router";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import {
    fetchCategory,
    fetchPaginatedCategories,
    getCategoryParentUuid
} from "@/_services/category/category";
import { ICategory } from "@/models/category/ICategory";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCategories',
  setup(__props) {

const route = useRoute();
const loading = ref<boolean>(true);
const categories: ICategory[] = [];
const tableData = ref<Array<ICategory>>(categories);
const uuidRouteParam = ref<string | null>(null);
const parents = ref(Array<object>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const modeSortable = ref<boolean>(false);
const categoryLabel = ref<string>("");
const title = ref<string>("Gérer les catégories");

onMounted(async () => {
    uuidRouteParam.value = route.params.uuid as string;
    categoryLabel.value = uuidRouteParam.value ? "sous-catégorie" : "catégorie";
    await populateDatatable(rows.value, page.value);
    if (uuidRouteParam.value) {
        let name = await getParentsCategory(tableData.value[0]);
        title.value = `Sous-catégories de ${name}`;
        /*
        setCurrentPageBreadcrumbs(`Sous-catégories de ${tableData.value[0].name}`, parents.value);*/
    } else {
        /*setCurrentPageBreadcrumbs(uuidRouteParam.value ? "Sous-catégorie" : "Catégorie", [
            {
                label: "Arborescence de catégories",
                link: { name: "apps-categories-treeview" },
            },
        ]);*/
    }
});

const getParentsCategory = async (category: ICategory) => {
  let parentUuid = getCategoryParentUuid(category);
  if (null !== parentUuid) {
    let parent = await fetchCategory(parentUuid);
    return parent.name;
  }
  return '';
}
const getParentsForBreadcrumb = async (category: ICategory) => {
    let parentUuid = getCategoryParentUuid(category);
    if (null !== parentUuid) {
        let parent = await fetchCategory(parentUuid);
        if (parent.lvl === 0) {
            parents.value.reverse();
            parents.value.unshift({
                label: "Catégories",
                link: { name: "listCategories" },
            });
            return;
        }
        parents.value.push({ label: parent.name, link: parent.uuid });
        getParentsForBreadcrumb(parent);
    }
};

const onFilterDt = () => {
    if (criteria.value != "") {
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable(e.rows, e.page + 1, criteria.value);
};

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchPaginatedCategories(
        itemsPerPage,
        page,
        uuidRouteParam.value,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
};

const checkArchiveCategory = (category) => {
    if (category.hasChildren) {
        swal.warning(
            "Vous ne pouvez pas archiver cette " +
            categoryLabel.value +
            " car ses sous-catégories ne sont pas archivées"
        );
    } else {
        swal
            .confirm(
                "Êtes-vous sûr de vouloir archiver cette " + categoryLabel.value + " ?"
            )
            .then((result) => {
                if (result.isConfirmed) {
                    archiveCategory(category.uuid);
                }
            });
    }
};

const archiveCategory = async (uuidCategory) => {
    await ApiService.patchWithoutSlug("categories/" + uuidCategory, { archived: true })
        .then(() => {
            swal
                .info("Cette " + categoryLabel.value + " a bien été archivée.")
                .then(() => {
                    tableData.value = tableData.value.filter(
                        (item) => item.uuid !== uuidCategory
                    );
                    let cpt = 1;
                    tableData.value.map((item) => (item.position = cpt++));
                });
        })
        .catch(() => {
            swal.error();
            return false;
        });
};

const changePositionCategory = async (e) => {
    let dragIndex = e.dragIndex;
    let dropIndex = parseInt(e.dropIndex) + (currentPage.value * rows.value);
    let uuidCategory = tableData.value[dragIndex].uuid;
    showSpinner();
    await ApiService.patchWithoutSlug("categories/" + uuidCategory, {
        position: dropIndex,
    })
        .then(() => {
            swal
                .info(`Les ${categoryLabel.value}s ont bien changé de position dans le mégamenu !`)
                .then(async () => {
                  await populateDatatable(rows.value, page.value);
                });
        })
        .catch(() => {
            swal.error();
            return false;
        });
    hideSpinner();
};

const onRowReorder = (e) => {
    if (criteria.value != "" || modeSortable.value) {
        swal.error(`Vous devez retirer les filtres afin de pouvoir modifier les positions des ${categoryLabel.value} s`);
        return false;
    }
    swal
        .confirm(`Souhaitez-vous changer l'ordre des ${categoryLabel.value} s dans le mégamenu ?`)
        .then((result) => {
            if (result.isConfirmed) {
                changePositionCategory(e);
            }
        });
};

const showSpinner = () => {
    loading.value = true;
}

const hideSpinner = () => {
    loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Ajouter une catégorie",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'addCategory' }))),
        icon: "pi pi-plus",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        rowHover: true,
        loading: loading.value,
        rowsPerPageOptions: [10, 25, 100],
        lazy: "",
        paginator: "",
        template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: onPaginate,
        onRowReorder: _cache[2] || (_cache[2] = ($event: any) => (onRowReorder($event))),
        onSort: _cache[3] || (_cache[3] = ($event: any) => (onSort($event))),
        removableSort: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "form-control w-[250px] ps-15",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                    onKeyup: _withKeys(onFilterDt, ["enter"]),
                    placeholder: "Rechercher une catégorie",
                    onInput: onClearInputFilter
                  }, null, 8, ["modelValue", "onKeyup"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (uuidRouteParam.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: 'addCategory', params: { uuid: uuidRouteParam.value } }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                          ]),
                          _createTextVNode(" Ajouter une sous-catégorie ")
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(Column), {
              rowReorder: true,
              headerStyle: "width: 3rem",
              reorderableColumn: false
            }),
            (!uuidRouteParam.value)
              ? (_openBlock(), _createBlock(_unref(Column), {
                  key: 0,
                  field: "vignette",
                  header: "Miniature"
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.vignette)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: slotProps.data.vignette.url,
                          class: "w-14"
                        }, null, 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Column), {
              field: "name",
              header: "Nom de la catégorie"
            }),
            _createVNode(_unref(Column), {
              field: "enabled",
              header: "Statut"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.enabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Activé"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, "Désactivé"))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "position",
              header: "Position"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.position), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              headerStyle: "width: 12em;",
              class: "whitespace-nowrap"
            }, {
              header: _withCtx(() => [
                _hoisted_17
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  to: { name: 'editCategory', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      type: "button",
                      icon: "pi pi-pencil ",
                      title: "Éditer",
                      class: "p-edition",
                      style: {"margin-right":"0.5em"}
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_unref(Button), {
                  onClick: ($event: any) => (checkArchiveCategory(slotProps.data)),
                  type: "button",
                  title: "Supprimer",
                  icon: "pi pi-trash",
                  class: "p-button-danger"
                }, null, 8, ["onClick"]),
                (slotProps.data.hasChildren)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.$router.resolve({name:'listCategories', params: {uuid: slotProps.data.uuid}}).href
                    }, [
                      _createVNode(_unref(Button), {
                        type: "button",
                        icon: "pi pi-eye",
                        title: "Voir les sous-catégories",
                        class: "p-button-success p-button-eye ml-2"
                      })
                    ], 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ], 64))
}
}

})